export default "__VITE_ASSET__B52QNmmi__"